var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ContactHero'),_c('ProcessSection'),_c('WhyChooseSection'),_c('FraudTypesSection'),_c('ClientsSaySection'),_c('FaqSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }